import { useState, useEffect, useRef } from "react";
import { FiNavigation2 } from "react-icons/fi";
import maplibregl from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";

function MapboxRobot(props) {
  const mapContainerRef = useRef(null); // Ref for the map container
  const mapRef = useRef(null); // Ref for the map instance
  const [robotMarker, setRobotMarker] = useState(null);
  const [dropMarker, setDropMarker] = useState(null);
  const [pickupMarker, setPickupMarker] = useState(null);
  const [pickupLocationPopup, setPickupLocationPopup] = useState(null);
  const [dropLocationPopup, setDropLocationPopup] = useState(null);
  const [userControllingMap, setUserControllingMap] = useState(false);

  useEffect(() => {
    const initializeMap = (props) => {
      const newMap = new maplibregl.Map({
        container: mapContainerRef.current,
        style: process.env.REACT_APP_MAP_STYLE || "https://raw.githubusercontent.com/go2garret/maps/main/src/assets/json/openStreetMap.json",
        zoom: process.env.REACT_APP_MAP_ZOOM,
        maxBounds: [
          props?.maxBoundCordinates?.southwest,
          props?.maxBoundCordinates?.northeast
        ],
      });

      mapRef.current = newMap;

      const robotMarkerDiv = document.createElement("div");
      robotMarkerDiv.style.width = "35px";
      robotMarkerDiv.style.height = "35px";
      robotMarkerDiv.style.borderRadius = "100%";
      robotMarkerDiv.style.backgroundImage =
        "url(/assets/images/robot-icon-2.svg)";

      const dropMarkerDiv = document.createElement("div");
      dropMarkerDiv.style.width = "35px";
      dropMarkerDiv.style.height = "35px";
      dropMarkerDiv.style.borderRadius = "100%";
      dropMarkerDiv.style.backgroundImage = "url(/assets/images/dropoff.svg)";

      const pickupMarkerDiv = document.createElement("div");
      pickupMarkerDiv.style.width = "35px";
      pickupMarkerDiv.style.height = "35px";
      pickupMarkerDiv.style.borderRadius = "100%";
      pickupMarkerDiv.style.backgroundImage =
        "url(/assets/images/PickUpLocation-icon.svg)";

      let newRobotMarker, newDropMarker, newPickupMarker;
      if (props?.robotActiveMission?.missionActions?.length) {
        let missionMarkers = Array(
          props?.robotActiveMission?.missionActions.length
        ).fill(new maplibregl.Marker({ element: dropMarkerDiv }), 0);
        missionMarkers.forEach((marker, index) => {
          marker
            .setLngLat([
              props?.robotActiveMission?.missionActions[index]?.longitude || 0,
              props?.robotActiveMission?.missionActions[index]?.latitude || 0,
            ])
            .addTo(newMap)
            .setPopup(
              new maplibregl.Popup({ offset: 25 }).setHTML(
                `<div class="custom-popup"><p>${props?.robotActiveMission.missionActions[index]?.locationName}</p></div>`
              )
            )
            .setLngLat([
              props?.robotActiveMission.missionActions[index]?.longitude || 0,
              props?.robotActiveMission.missionActions[index]?.latitude || 0,
            ]);
        });
      }
      console.log("props?.robotLocation", props?.robotLocation);
      if (props?.robotLocation) {
        newRobotMarker = new maplibregl.Marker({ element: robotMarkerDiv })
          .setLngLat([
            props?.robotLocation?.longitudeSlam || 0,
            props?.robotLocation?.latitudeSlam || 0,
          ])
          .addTo(newMap);
        setRobotMarker(newRobotMarker);
      }
      if (props?.orderDropLocation) {
        newDropMarker = new maplibregl.Marker({ element: dropMarkerDiv })
          .setLngLat([0, 0])
          .addTo(newMap);
        const dropPopup = new maplibregl.Popup({
          closeButton: false,
          closeOnClick: false,
        });

        dropPopup
          .setLngLat([0, 0])
          .addTo(newMap)
          .setHTML(
            `<div class="custom-popup"><p>${props?.orderDropLocation?.locationName?props?.orderDropLocation?.locationName:"Drop"}</p></div>`
          );
        setDropLocationPopup(dropPopup);
        setDropMarker(newDropMarker);
      }
      if (props?.orderPickupLocation) {
        newPickupMarker = new maplibregl.Marker({ element: pickupMarkerDiv })
          .setLngLat([0, 0])
          .addTo(newMap);

        const pickupPopup = new maplibregl.Popup({
          closeButton: false,
          closeOnClick: false,
        });

        pickupPopup
          .setLngLat([0, 0])
          .addTo(newMap)
          .setHTML(
            `<div class="custom-popup"><p>${props?.orderPickupLocation?.locationName?props?.orderPickupLocation?.locationName:"Pickup"}</p></div>`
          );
        setPickupLocationPopup(pickupPopup);
        setPickupMarker(newPickupMarker);
      }
    };

    if (!mapRef.current) {
      initializeMap(props);
    }
  }, [mapRef, props]);
  const isLatitude = (num) => isFinite(num) && Math.abs(num) <= 90;

  const isLongitude = (num) => isFinite(num) && Math.abs(num) <= 180;

  useEffect(() => {
    if (robotMarker) {
      if (props?.robotLocation?.headingSlam || props?.robotLocation?.heading) {
        let rotation = parseFloat(props?.robotLocation?.headingSlam || 0);
        robotMarker.setRotation(rotation).setRotationAlignment("map");
      }
    }

    if (dropMarker) {
      dropMarker
        .setLngLat([
          parseFloat(props?.orderDropLocation?.longitude) || 0,
          parseFloat(props?.orderDropLocation?.latitude) || 0,
        ])
        .setRotationAlignment("map");

      dropLocationPopup
        .setLngLat([
          props?.orderDropLocation?.longitude || 0,
          props?.orderDropLocation?.latitude || 0,
        ])
        .setHTML(
          `<div class="custom-popup"><p>${props?.orderDropLocation?.locationName?props?.orderDropLocation?.locationName:"Drop"}</p></div>`
        );
    }

    if (pickupMarker) {
      pickupMarker
        .setLngLat([
          parseFloat(props?.orderPickupLocation?.longitude) || 0,
          parseFloat(props?.orderPickupLocation?.latitude) || 0,
        ])
        .setRotationAlignment("map");
      pickupLocationPopup
        .setLngLat([
          props?.orderPickupLocation?.longitude || 0,
          props?.orderPickupLocation?.latitude || 0,
        ])
        .setHTML(
          `<div class="custom-popup"><p>${props?.orderPickupLocation?.locationName?props?.orderPickupLocation?.locationName:"Pickup"}</p></div>`
        );
    }

    if (
      !userControllingMap &&
      !!Number(process.env.REACT_APP_USER_MAP_CONTROL) &&
      isLatitude(props?.orderDropLocation?.latitude) &&
      isLongitude(props?.orderDropLocation?.longitude) &&
      isLatitude(props?.robotLocation?.latitudeSlam) &&
      isLongitude(props?.robotLocation?.longitudeSlam) &&
      isLatitude(props?.orderPickupLocation?.latitude) &&
      isLongitude(props?.orderPickupLocation?.longitude)
    ) {
        const bounds = new maplibregl.LngLatBounds(
          [
            props?.robotLocation?.longitudeSlam,
            props?.robotLocation?.latitudeSlam,
          ],
          [
            props?.orderPickupLocation?.longitude,
            props?.orderPickupLocation?.latitude,
          ]
        );
        bounds.extend([
          props?.orderDropLocation?.longitude || 0,
          props?.orderDropLocation?.latitude || 0
        ]);
        bounds.extend( [
          props?.robotLocation?.longitudeSlam,
          props?.robotLocation?.latitudeSlam,
        ]);
        bounds.extend( [
          props?.orderPickupLocation?.longitude,
          props?.orderPickupLocation?.latitude,
        ]);
        mapRef.current.fitBounds(bounds, {
          padding: 100,
          duration: 200,
        });
    }
    //  else {
    //   const bounds = new maplibregl.LngLatBounds(
    //     props?.maxBoundCordinates?.southwest,
    //     props?.maxBoundCordinates?.northeast
    //   );

    //   bounds.extend([
    //     props?.orderDropLocation?.longitude || 0,
    //     props?.orderDropLocation?.latitude || 0
    //   ]);

    //   mapRef.current.fitBounds(bounds, {
    //     padding: 80,
    //     duration: 200,
    //   });
    // }
  }, [
    props,
    props?.orderDropLocation,
    props?.robotLocation,
    robotMarker,
    dropMarker,
    pickupMarker,
    dropLocationPopup,
    pickupLocationPopup,
    userControllingMap,
  ]);

  useEffect(() => {
    if (!mapRef.current) return;
    const map = mapRef.current;
  
    // Only set userControlling when the event is from an actual user interaction
    // (mouse/touch/wheel), not from programmatic flyTo/easeTo calls
    const startControl = (e) => {
      if (e.originalEvent) {
        setUserControllingMap(true);
      }
    };
  
    map.on('dragstart', startControl);
    map.on('zoomstart', startControl);
    map.on('rotatestart', startControl);
  
    return () => {
      map.off('dragstart', startControl);
      map.off('zoomstart', startControl);
      map.off('rotatestart', startControl);
    };
  }, []);

  useEffect(() => {
        // Lazily create robot marker if it doesn't exist yet but location data is now available
        if (!robotMarker && props?.robotLocation && mapRef.current) {
          const robotMarkerDiv = document.createElement("div");
          robotMarkerDiv.style.width = "35px";
          robotMarkerDiv.style.height = "35px";
          robotMarkerDiv.style.borderRadius = "100%";
          robotMarkerDiv.style.backgroundImage =
            "url(/assets/images/robot-icon-2.svg)";

          const lng = props?.robotLocation?.longitudeSlam || 0;
          const lat = props?.robotLocation?.latitudeSlam || 0;

          const newRobotMarker = new maplibregl.Marker({ element: robotMarkerDiv })
            .setLngLat([lng, lat])
            .addTo(mapRef.current);
          setRobotMarker(newRobotMarker);

          // Fly to robot location on first appearance
          if (isLongitude(lng) && isLatitude(lat)) {
            mapRef.current.flyTo({
              center: [lng, lat],
              zoom: 18,
              duration: 1500,
            });
          }
          return; // state update will re-trigger this effect
        }

        // move robot marker
        if (robotMarker) {
          const lng = isLongitude(props?.robotLocation?.longitudeSlam)
            ? props?.robotLocation?.longitudeSlam
            : 0;
          const lat = isLatitude(props?.robotLocation?.latitudeSlam)
            ? props?.robotLocation?.latitudeSlam
            : 0;

          if (
            !!Number(process.env.REACT_APP_HEADING) &&
            (props?.robotLocation?.headingSlam || props?.robotLocation?.heading)
          ) {
            if (Number(process.env.REACT_APP_HEADING_ROTATION)) {
              robotMarker
                .setLngLat([lng, lat])
                .setRotation(
                  parseFloat(
                    props?.robotLocation?.headingSlam
                      ? props?.robotLocation?.headingSlam
                      : props?.robotLocation?.heading
                  )
                )
                .setRotationAlignment("map");
            } else {
              robotMarker
                .setLngLat([lng, lat])
                .setRotationAlignment("map");
            }
          } else {
            robotMarker.setLngLat([lng, lat]);
          }

          // Track the robot: keep it centered unless user took control
          if (!userControllingMap && mapRef.current && isLongitude(lng) && isLatitude(lat)) {
            mapRef.current.easeTo({
              center: [lng, lat],
              duration: 500,
            });
          }
        }
  },[ props?.robotLocation,
    robotMarker,
    userControllingMap])

  // Add geofence overlay — grey out everything outside the geofence polygon
  useEffect(() => {
    if (!mapRef.current || !props?.geofenceCoordinates || props.geofenceCoordinates.length === 0) return;

    const map = mapRef.current;

    // World polygon (outer ring) — covers the entire globe
    const worldBounds = [
      [-180, -90],
      [-180, 90],
      [180, 90],
      [180, -90],
      [-180, -90],
    ];

    // Ensure the geofence ring is closed
    const geofenceRing = [...props.geofenceCoordinates];
    const first = geofenceRing[0];
    const last = geofenceRing[geofenceRing.length - 1];
    if (first[0] !== last[0] || first[1] !== last[1]) {
      geofenceRing.push(first);
    }

    const addGeofence = () => {
      if (!map.getSource("geofence-mask")) {
        // Inverted polygon: outer ring = world, inner ring = geofence (hole)
        map.addSource("geofence-mask", {
          type: "geojson",
          data: {
            type: "Feature",
            properties: {},
            geometry: {
              type: "Polygon",
              coordinates: [worldBounds, geofenceRing],
            },
          },
        });

        // Grey fill outside geofence
        map.addLayer({
          id: "geofence-mask-fill",
          type: "fill",
          source: "geofence-mask",
          paint: {
            "fill-color": "#000000",
            "fill-opacity": 0.55,
          },
        });

        // Geofence border outline
        map.addSource("geofence-outline", {
          type: "geojson",
          data: {
            type: "Feature",
            properties: {},
            geometry: {
              type: "Polygon",
              coordinates: [geofenceRing],
            },
          },
        });

        map.addLayer({
          id: "geofence-outline-layer",
          type: "line",
          source: "geofence-outline",
          paint: {
            "line-color": "#FF0000",
            "line-width": 3,
          },
        });
      }
    };

    if (map.loaded()) {
      addGeofence();
    } else {
      map.once("load", addGeofence);
    }

    return () => {
      if (map.getLayer("geofence-mask-fill")) map.removeLayer("geofence-mask-fill");
      if (map.getSource("geofence-mask")) map.removeSource("geofence-mask");
      if (map.getLayer("geofence-outline-layer")) map.removeLayer("geofence-outline-layer");
      if (map.getSource("geofence-outline")) map.removeSource("geofence-outline");
    };
  }, [props?.geofenceCoordinates]);

  // Add robot path if provided
  useEffect(() => {
    if (!mapRef.current || !props?.robotPath || props.robotPath.length === 0) return;

    const map = mapRef.current;

    const addPath = () => {
      if (!map.getSource("robot-path")) {
        map.addSource("robot-path", {
          type: "geojson",
          data: {
            type: "Feature",
            properties: {},
            geometry: {
              type: "LineString",
              coordinates: props.robotPath,
            },
          },
        });

        map.addLayer({
          id: "robot-path-layer",
          type: "line",
          source: "robot-path",
          layout: {
            "line-join": "round",
            "line-cap": "round",
          },
          paint: {
            "line-color": "#00A16F",
            "line-width": 4,
            "line-opacity": 0.7,
          },
        });
      } else {
        map.getSource("robot-path").setData({
          type: "Feature",
          properties: {},
          geometry: {
            type: "LineString",
            coordinates: props.robotPath,
          },
        });
      }
    };

    if (map.loaded()) {
      addPath();
    } else {
      map.once("load", addPath);
    }

    return () => {
      if (map.getLayer("robot-path-layer")) {
        map.removeLayer("robot-path-layer");
      }
      if (map.getSource("robot-path")) {
        map.removeSource("robot-path");
      }
    };
  }, [props?.robotPath, mapRef]);

  return (
    <div style={{ height: "100%", position: "relative" }}>
      {!robotMarker && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "rgba(255,255,255,0.7)",
            zIndex: 2,
          }}
        >
          <style>{`@keyframes spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}`}</style>
          <div
            style={{
              border: "4px solid rgba(0,0,0,0.1)",
              borderTop: "4px solid #00A16F",
              borderRadius: "50%",
              width: "40px",
              height: "40px",
              animation: "spin 1s linear infinite",
            }}
          ></div>
        </div>
      )}
      {userControllingMap &&
      !!Number(process.env.REACT_APP_USER_MAP_CONTROL) ? (
        <div
          className={`cursor-pointer flex items-center gap-2 sidebar bg-[#00B7D4] text-white p-[6px_12px] z-[1] absolute bottom-0 left-0 m-1 rounded-[4px] h-[30px]`}
          onClick={() => setUserControllingMap(false)}
        >
          <FiNavigation2 strokeWidth={3} />
          <span className="text-xs font-bold uppercase">Re-centre</span>
        </div>
      ) : null}
      <div
        ref={mapContainerRef}
        id="map-container-id"
        className="map-container"
        style={{
          height: "100%",
          position: "absolute",
          width: "100%",
        }}
      ></div>
    </div>
  );
}

export default MapboxRobot;
